<template>
  <div class="home_link vue_flex vue_warp">
    <div class="vue_flex vue_column vue_flex_between" v-for="(link, linkIndex) in list" :key="linkIndex" @click="linkboxs(link)">
      <p class="vue-font-PingFang-500 color_35 font20 line_height_20">{{link.tit}}</p>
      <p class="vue-font-PingFang-800 color_35 font32 line_height_32">{{link.num}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    linkboxs(item) {
      console.log("item", item);
      this.$emit("itemClick", item);
    },
  },
};
</script>

<style scoped lang="scss">
.home_link{
  background-image: url('../../assets/ym/xxk.png');
  padding: 22px 26px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  gap: 17px;
  margin-top: 30px;
  div{
    width: 231px;
    height: 130px;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 15px;
    padding: 27px 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/linkwhole/index.vue